import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	PostExamsConfirm,
	MakeExamsConfirmParams,
	MakeExamsConfirmParamsModel,
} from 'domain/usecases';

export class RemotePostExamsConfirm implements PostExamsConfirm {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<MakeExamsConfirmParamsModel>,
	) {}

	async post(params: MakeExamsConfirmParams): Promise<MakeExamsConfirmParamsModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
